import "./MainCarousel.css";
import LinkContainer from "react-router-bootstrap/LinkContainer";
import { Carousel, Row, Col, Card } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import { carouselItemsPerPage } from "../../constants/config";

export default function MainCarousel(props) {
  // renders multiple items per slide and supports navigation to individual item details when clicked

  return !props.items || props.items.length < 1 ? null : (
    <Carousel indicators={false} variant="dark">
      {props.items?.map((item, index) => {
        const itemsPerPage = Math.min(
                  carouselItemsPerPage,
                  props.items.length
                );
        const startIdx = (index * itemsPerPage) % props.items.length;
        const currIndices = Array.from(
          { length: itemsPerPage },
          (_, idx) =>
            (startIdx + idx + itemsPerPage) % props.items.length
        );
        return (
          <Carousel.Item key={item?._id} data-testid="carousel-item">
            <Row > 
              {currIndices.map((currIdx, _) => {
                const product = props.items[currIdx];
                return (
                  <Col
                    xs={6}
                    md={12 / itemsPerPage}
                    key={currIdx}
                  >
                    <LinkContainer
                      data-testid={product._id}
                      to={`/product-details/${product?._id}`}
                      style={{ cursor: "pointer", border: "none" }}
                    >
                      <Card style={{ border: "none" }}>
                        <Card.Img
                          className="carousel-image"
                          style={{
                            maxHeight: "230px",
                            maxWidth: "230px",
                            alignSelf: "center",
                            objectFit: "cover",
                          }}
                          src={product?.imageUrl || null}
                        />
                        <Card.Body style={{ textAlign: "center" }}>
                          <Card.Text
                            className="carousel-card-text"
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: "large",
                            }}
                          >
                            {product?.name}
                          </Card.Text>
                          <Card.Text className="category-name carousel-card-text">
                            {product?.categoryName}
                          </Card.Text>
                          {/* <Card.Text
                            style={{ textAlign: "center" }}
                            className="item-description carousel-card-text"
                          >
                            {product?.description}
                          </Card.Text> */}
                          <Card.Text>
                            <span
                              className="price carousel-card-text"
                              style={{
                                fontSize: "large",
                                fontWeight: "500",
                              }}
                            >
                              {product.price.toLocaleString("en-CA", {
                                style: "currency",
                                currency: "CAD",
                              })}
                            </span>
                          </Card.Text>
                          <Card.Text>
                            <span
                              className="carousel-card-text m-0"
                              style={{
                                fontSize: "35px",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "start",
                              }}
                            ></span>
                            <Rating
                              readonly
                              size={25}
                              initialValue={product?.rating}
                              allowFraction={true}
                              className="m-0"
                            />
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </LinkContainer>
                  </Col>
                );
              })}
            </Row>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}
